export default [
	[
		{
			index: 'id',
			header: {
				title: 'id'
			},
			column: {}
		},
		{
			index: 'text',
			header: {
				title: 'text'
			},
			column: {
				className: 'popups-campaigns-table-text'
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/custom-content/list/table-initial-data.js